// extracted by mini-css-extract-plugin
export default {"content":"CardContainer_content__CM2f2","card-wrapper":"CardContainer_card-wrapper__VVZJ0","section-wrapper":"CardContainer_section-wrapper__aGHOr"};